module.exports = __webpack_public_path__ + "img/empilhadeiras_CARD.3462b34b.jpg";